import React from "react"
import {Container, Navbar} from "react-bootstrap";
import '../styles/App.css';
import {useLocation} from "react-router-dom";

const TopNavSub = () => {

    const location = useLocation();

    let navBarText = ''; 

    if(location.pathname === "/auth"){
        navBarText = 'Get Your Token';
    } else if(location.pathname === "/documentation/invoice-submission") {
        navBarText = 'VAT IT Invoice Submissions';
    } else if (location.pathname === "/documentation") {
        navBarText = 'All Documentation';
    } else {
        navBarText = 'Get Your Token';
    }

    // 'VAT IT Invoice Submissions'
    let showLicenseLink = false;

    return (
        <Navbar className="horizontal-2nd-nav horizontal-nav secondary-color">
            <Container>
                <Navbar.Brand className="header-nav-text">{navBarText}</Navbar.Brand>
                <Navbar.Toggle/>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        {showLicenseLink && <div>License Text</div>}
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default TopNavSub;
